import { createContext, useContext, useState } from "react";

const LastEnrollmentStepContext = createContext(undefined);

export function LastEnrollmentStepProvider({ children }) {
  const [LastEnrollmentStep, setLastEnrollmentStep] = useState(false);

  return (
    <LastEnrollmentStepContext.Provider
      value={{ LastEnrollmentStep, setLastEnrollmentStep }}
    >
      {children}
    </LastEnrollmentStepContext.Provider>
  );
}

export function useLastEnrollmentStep() {
  const context = useContext(LastEnrollmentStepContext);
  if (!context) {
    throw new Error(
      "useLastEnrollmentStep must be used within a LastEnrollmentStepProvider",
    );
  }
  return context;
}
